import { useState } from "react";
import { useNavigate } from "react-router-dom";
import menuIcon from "../../assets/icons/menu-hamburguer.svg";
import logoImg from "../../assets/icons/logo-lisa.svg";
import {HeaderContainer,LogoSection,Title,MenuButton,MenuDropdown,MenuItem
} from "./styles";

interface PanelHeaderProps {
  title?: string;
}

export function PanelHeader({ title}: PanelHeaderProps) {
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();

  const handleMenuClick = (route: string) => {
    setShowMenu(false);
    navigate(route);
  };

  const handleLogout = () => {
    setShowMenu(false);
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    navigate("/login");
  };

  return (
    <HeaderContainer>
      <LogoSection>
        <img src={logoImg} alt="Logo" />
        <Title>{title}</Title>
      </LogoSection>

      <MenuButton onClick={() => setShowMenu(!showMenu)} aria-label="Menu">
        <img src={menuIcon} alt="Menu" />
        {showMenu && (
          <MenuDropdown>
            <MenuItem onClick={() => handleMenuClick("/home")}>
              Home
            </MenuItem>
            <MenuItem onClick={() => handleMenuClick("/interprete")}>
              Painel do intérprete
            </MenuItem>
            <MenuItem onClick={() => handleMenuClick("/dashboard")}>
              Dashboard
            </MenuItem>
            <MenuItem onClick={handleLogout}>
              Sair
            </MenuItem>
          </MenuDropdown>
        )}
      </MenuButton>
    </HeaderContainer>
  );
}
